import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from 'react-bootstrap' ;
import Backdrop  from '@material-ui/core/Backdrop' ;
import {makeStyles} from '@material-ui/core/styles' ;
import Button from '@material-ui/core/Button' ;
import styles from './CustomControl.module.css' ;
import {AppContext} from '../../../Resources/CanvasContextFile' ;
import RedCross from '../../../Icons/RedCross';
import AddColumnIcon from '../../../Icons/AddColumnIcon';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {TableTextboxForCustomControl} from "../../../UI/BasicFormControls/TableRow" ;
import ImageUploadBtn from '../../../ReusableComponents/ImageUploadBtn/ImageUploadBtn';
import { useSelector } from "../../../Redux";
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from "react-i18next";
import { GetStateFromData } from "../../CustomHooks/CustomHooks";
import { encrypt,decryptMessage } from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import { Dialog } from "@material-ui/core";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";


const useStyles = makeStyles((theme) => ({
    backdrop: {
      // width: '1047px',
      // height: '394px',
      width:"100%",
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    dialogPaperWidthSm: {
      maxWidth: '100%',
    },
  }));
  

export default function CustomControl(props) {
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"; 
    const {t}=useTranslation();
    const contexts = GetStateFromData();

  const { formState2 } = contexts.contexts;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [controlSetDetails, setcontrolSetDetails] = React.useState([]);
  const [modified, setModified] = React.useState(false);
//   const [selectedControlSetIndex, setSelectedControlSetIndex] = React.useState(0);
  const [selectedControlSetIndex, setSelectedControlSetIndex] = React.useState(-1);
  const [filteredCustomControlName, setFilteredCustomControlName] = React.useState({'customControlName' : '','customControlId' : ''});
  
  const [selectedTemplateOption, setSelectedTemplateOption] = React.useState();
  const [showCollapsibleBody, setShowCollapsibleBody] = React.useState(false);
  const [number, setNumber] = React.useState(0);
  const [inputValue,setInputValue] = useState("");
  const [isEditEnable,setIsEditEnable] = useState(false);


  const [customIconDetails, setCustomIconDetails] = React.useState({'iconName' : '','iconFile' : ''});

  var formState;
  var controlSetJson1 = {  } ;
  var controlSetJson = {  };  

//   console.log("formState2344 ", formState2['customControl']);

  if(contexts!==undefined){
    if(formState2!==undefined && Object.keys(controlSetJson).length === 0){  
        formState = formState2 ;
        if(modified=== false){ 
            if(formState.customControl){
                setcontrolSetDetails(formState['customControl']) ;
            }
            else {
                // setcontrolSetDetails([{'label':'Custom Control 1', 'elem_type': 'CustomControl', 'properties' : [  ]}]) ;
                setcontrolSetDetails([]) ;

            }
            setModified(true) ;
        }
        
        // controlSetJson = readFormData(formState.children, controlSetJson,controlSetJson1) ;
    }
  }

  const [disableSave , setDisableSave] = useState(false);
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
    });

  const handleToggle = () => {
    setOpen(!open);
  };

  function saveControlSet(arg){ // console.log("formstate: ",formState) ;
      if(arg === 'Cancel'){  }
      if(arg === 'Save'){
             
                formState['customControl'] = controlSetDetails ;
            
        
      }
      props.setShowCustomControlBackdrop() ;
  }
  function saveImage(){  }
  function filterSearchedItem(action,searchedText){   
    if(action === 'customControlName' ){   
        //   controlSetDetails.map((controlSet)=>{
        //         if(controlSet.label && controlSet.label.includes(searchedText)){ 
                    setFilteredCustomControlName((prev)=> {return{...prev, 'customControlName' : searchedText}});
        //         } 
        //   });    
    }
    else if(action==='controlId'){ 
        setFilteredCustomControlName((prev)=> {return{...prev, 'controlId' : searchedText}});
    }
    else if(action==='controlName'){ 
        if(searchedText === 'horizontal'){ 
        
        }
    }
  }
  function handleControlSetDetails(action, controlDetails){ // console.log(controlDetails) ;
    if(action === 'addDelete'){
        setcontrolSetDetails(
            controlSetDetails.map((controlSet, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex ){
                    if(controlSet[controlDetails.id]){
                        delete(controlSet[controlDetails.id])
                        return {...controlSet}
                    }
                    else{
                        return {...controlSet, [controlDetails.id] : controlDetails }
                    }
                }
                
                return controlSet
            }))
    }
    else if(action === 'Creatwqe'){
        
    }

  }
  function handleProperty(action,key,value,index,isEncrypt = ""){ 
    // console.log(action,key,value);
      if(action === 'addpropertyRow'){
        setcontrolSetDetails(
            controlSetDetails.map((customControl, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex ){
                    let propName = 'property_name' + (customControl['properties'].length +1) ;
                    let propValue = 'property_value' + (customControl['properties'].length +1) ;
                    customControl['properties'].push({[propName] : propValue }) ;
                    return {...customControl};
                }
                
                return customControl
            }))
      }
      else if(action === 'propertyName'){
        if(value===''){
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "PROPERTY_NAME_MISSING",
              autoHideDuration: 4000
            });

            setDisableSave(true);
        } else {
        setcontrolSetDetails(
            controlSetDetails.map((customControl, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex){ // console.log('before::',customControl);
                    let temp_CustomControl = customControl['properties'][index] ;
                    temp_CustomControl =  {[value] :  temp_CustomControl[key]};
                    customControl['properties'][index] = temp_CustomControl ;
                    return {...customControl };
                }
                
                return customControl
        }));
            setDisableSave(false);
        }
      }
      else if(action === 'propertyValue'){
          if(value===''){
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "PROPERTY_VALUE_MISSING",
              autoHideDuration: 4000
            });

            setDisableSave(true);
        } else {
        setcontrolSetDetails(
            controlSetDetails.map((customControl, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex ){
                    let temp_CustomControl = customControl['properties'][index] ;
                    temp_CustomControl[key] =   value;
                    customControl['properties'][index] = temp_CustomControl ;
                    return {...customControl};
                }
                
                return customControl
            }));
            setDisableSave(false);
        }

      }
      else if(action === 'delete'){
        setcontrolSetDetails(
            controlSetDetails.map((customControl, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex ){
                    customControl['properties'].splice(index,1);
                    return {...customControl };
                }
                
                return customControl
            }))
      }

      if(isEncrypt === "encrypt"){
        decryptMessage_dblinking(value,key,index);
      }
    } // console.log(controlSetDetails);

    function handleIcon(imageName, imageFile){

    
        // setCustomIconDetails({'iconFile':imageFile}, {'iconName':imageName})

        setCustomIconDetails((prev)=> {return{...prev, 'iconFile':imageFile, 'iconName':imageName}});

      //  setCustomIconDetails((prev)=> {return{...prev, 'customControlName' : searchedText}});
        // setCustomIconDetails({'iconName':imageName})

     //   setFilteredCustomControlName((prev)=> {return{...prev, 'customControlName' : searchedText}});
        
        //  React.useState({'iconName' : '','iconFile' : ''});

        setcontrolSetDetails(
            controlSetDetails.map((customControl, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex ){
                    customControl['iconName'] = imageName ;
                    customControl['iconFile'] = imageFile ;
                    return {...customControl};
                }
                
                return customControl
            }))
      
    }

   
  function handleControlSet(action,index,controlId){  
    if(action === 'create'){
        if(index != undefined || inputValue){
            setcontrolSetDetails(prev => [...prev, {'label' : `${inputValue}`, 'elem_type':'CustomControl','properties'  : [], 'iconFile':customIconDetails.iconFile,
            'iconName':customIconDetails.iconName  }]) ;
            setCustomIconDetails({'iconFile':'', 'iconName':''});
            setSelectedControlSetIndex(controlSetDetails.length) ;
            setInputValue("");

            // props.setShowCustomControlBackdrop();

        }else{
            setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "CONTROL_NAME_MISSING",
                autoHideDuration: 4000
              });
        }
        
    } 
    else if(action === 'selectedControlSet'){
        setSelectedControlSetIndex(index) ;
    }
    else if(action === 'changeLabel'){ 
        if(index===''){
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "CONTROL_NAME_MISSING",
              autoHideDuration: 4000
            });
            // setDisableSave(true);
        } else {

        setcontrolSetDetails(
            controlSetDetails.map((controlSet, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex )
                    return {...controlSet, 'label' : inputValue}
                return controlSet
        }))
        setDisableSave(false);
        }
    } 
    else if(action === 'delete'){
        var controlSetBeforeDeletion = [...controlSetDetails];
        controlSetBeforeDeletion.splice(index, 1); 
        // setSelectedControlSetIndex(Math.min(selectedControlSetIndex, controlSetBeforeDeletion.length-1));
        setSelectedControlSetIndex(-1);
        setcontrolSetDetails(controlSetBeforeDeletion);
    }
    
  }



  function setInputValueHandler(event){

        setInputValue(event.target.value);
   
  }
  useEffect(()=>{
    document.getElementById("backdropDiv")?.focus();
    
   },[])
  function handleEscapeKey(e){
    if(e.code === "Escape"){
        saveControlSet('Cancel')
    } 
   }
  
   const [decrypt_msg_dblinking , setdecrypt_msg_dblinking]= React.useState([]);

   async function decryptMessage_dblinking(value,key,index){
     let res = await decryptMessage(value);

     setdecrypt_msg_dblinking(prev => {
        let prev_obj = prev;
        prev_obj[index] = { [key] : res };

        return [...prev_obj ]
    });

    // if( controlSetDetails?.[selectedControlSetIndex]?.properties?.[index] ){
    //     controlSetDetails[selectedControlSetIndex].properties[index] = { [key] : value };
    // }
    if( controlSetDetails?.[selectedControlSetIndex]?.properties?.[index] ){

        setcontrolSetDetails(
            controlSetDetails.map((customControl, setIndex)=>{ 
                if(setIndex === selectedControlSetIndex){ // console.log('before::',customControl);
                    let temp_CustomControl = customControl['properties'][index] ;
                    temp_CustomControl =  { [key] : value };
                    customControl['properties'][index] = temp_CustomControl ;
                    return {...customControl };
                }

                return customControl
        }));
    }


   }

   const decrypt_msg_dblinking_ref = React.useRef([]);
   

   useEffect(()=>{

    // decrypt_msg_dblinking_ref.current = 
    controlSetDetails?.[selectedControlSetIndex]?.properties?.map((obj, index)=>{
        decrypt_msg_dblinking_ref.current[index] = JSON.parse(JSON.stringify(obj));
    })

    if(controlSetDetails?.[selectedControlSetIndex]?.properties){

        let decypted_value = controlSetDetails?.[selectedControlSetIndex]?.properties.map( async (obj, ind)=>{
            let val_dec = Object.values(obj)[0];
            val_dec = await decryptMessage(val_dec);

            let key = Object.keys(obj)[0];
            let dec_obj = {[key] : val_dec};

            decrypt_msg_dblinking_ref.current[ind] = dec_obj;

            if( controlSetDetails?.[selectedControlSetIndex]?.properties?.length===ind+1 ){
                setdecrypt_msg_dblinking(decrypt_msg_dblinking_ref.current)
            }

        })

        
    }
  },[selectedControlSetIndex])

  return (
    <div>
      <Button disableFocusRipple
            disableRipple
            tabIndex={0} className={`formBuilder-MuiButton-outlined`}
            variant="outlined" color="primary" onClick={handleToggle}>
        Show backdrop
      </Button>
      
  <Dialog  classes={{
        paperWidthSm: classes.dialogPaperWidthSm, 
      }} className={classes.backdrop} open={true} >
      <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} className={styles.backdropDiv} id="backdropDiv">
        <Row className={styles.backdropHeader}>
            {t('Custom Control')} 
        </Row>
        <Row className={styles.backdropBody}>
            
                <Col className={styles.backdropLeftBody} onClick={()=>{setSelectedControlSetIndex(-1)}}>
                   <Col className={styles.controlSetAddCol}>
                        {t('Custom Control')}
                    </Col>
                    <Col className={styles.searchCol}>
                        <input aria-label={"Search Value"}  type='text' placeholder={t('Search')} className={styles.searchInput} 
                        onChange={(event)=>filterSearchedItem('customControlName',event.target.value)} />
                        <img src= {require('../../../Icons/Search.svg').default}  className={styles.searchIcon} style={translationStyles1?{left:"8px",right:"unset"}:null}  alt='Search Icon'/>
                    </Col>
                    <div className={styles.controlSetNameColParent}>
                    {   filteredCustomControlName && filteredCustomControlName['customControlName'].length === 0 ? 
                        controlSetDetails && controlSetDetails.map((controlSet, index)=>{
                        return(
                            <Col className={[styles.controlSetNameCol, selectedControlSetIndex === index ? styles.selectedControlSet : null].join(' ')} 
                            onClick={(e)=>{e.stopPropagation();handleControlSet('selectedControlSet', index)}}
                            >
                                <span className={styles.pageTitleText} onClick={(e)=>{e.stopPropagation();handleControlSet('selectedControlSet', index)}}>{controlSet.label}</span>
                                {selectedControlSetIndex === index ?
                                <span>
                                    {/* <IconButton className={styles.iconButton} onClick={(e)=>{e.stopPropagation();setIsEditEnable(true)}}>
                                    <EditIcon className={styles.EditIcon} fontSize={"inherit"} />
                                    </IconButton> */}
                                    <img 
                                        src={require('../../../Icons/EditIcon2.svg').default} 
                                        className={styles.EditIcon}  
                                        onClick={(e)=>{e.stopPropagation();setIsEditEnable(true)}}
                                        alt='Edit Icon'
                                    />
                                    {/* <div
                                        className={styles.iconButton} 
                                        onClick={(e)=>{e.stopPropagation();setIsEditEnable(true)}}
                                    >
                                        <EditIcon className={styles.EditIcon} fontSize={"inherit"} />
                                    </div> */}
                                    <img 
                                        src={require('../../../Icons/deleteRed.svg').default} 
                                        className={styles.deleteEditIcon}  
                                        onClick={(e)=>{e.stopPropagation(); handleControlSet('delete', index);}}
                                        alt='Delete Icon'
                                    />
                                </span>
                                :
                                <></>
                                }
                                
                            </Col>
                            )
                        })
                    :
                        controlSetDetails && controlSetDetails.map((controlSet, index)=>{
                        return(
                            controlSet.label && controlSet.label.toLowerCase().includes(filteredCustomControlName['customControlName'].toLocaleLowerCase()) ?
                            <Col className={[styles.controlSetNameCol, selectedControlSetIndex === index ? styles.selectedControlSet : null].join(' ')} 
                            onClick={(e)=>{e.stopPropagation(); handleControlSet('selectedControlSet', index)}}
                            >
                                <span className={styles.pageTitleText} onClick={(e)=>{e.stopPropagation(); handleControlSet('selectedControlSet', index)}}>
                                    {controlSet.label}
                                </span>
                                {selectedControlSetIndex === index ?
                                <span> 
                                    <img src= {require('../../../Icons/deleteRed.svg').default} className={styles.deleteEditIcon}  
                                    onClick={(e)=>{e.stopPropagation(); handleControlSet('delete', index)}}
                                    alt='Delete Icon'
                                    />
                                </span>
                                :
                                <></>
                                }
                                
                            </Col>
                            :<></>
                            )
                        })
                    }
                    </div>
                </Col>
                <Col className={styles.backdropRightBody}>
                    
                    <Col className={styles.controlSetNameWriteSearchCol} onClick={()=>('All')}>
                        <Col className={styles.customControlNameCol}>
                            <span className={styles.pageTitleText2} onClick={()=>handleControlSet()}>
                            {t('Custom Control Name')}
                            </span>
                            <input 
                                aria-label={"Custom Control Name"} 
                                key={controlSetDetails[selectedControlSetIndex] && 
                                selectedControlSetIndex+controlSetDetails[selectedControlSetIndex].label} 
                                type='text' 
                                placeholder={t('Enter Custom Control Name')}
                                maxLength={30}
                                className={isEditEnable ? styles.controlSetNameInput : selectedControlSetIndex!==-1 ? 
                                    styles.controlSetNameInputDisabled : styles.controlSetNameInput} 

                                disabled={isEditEnable ? false : selectedControlSetIndex!==-1 ? true : false}

                                defaultValue={selectedControlSetIndex!==-1 ? controlSetDetails[selectedControlSetIndex] && controlSetDetails[selectedControlSetIndex].label  : null} 

                                //  onChange={(event)=>{setInputValue(event.target.value)}}

                                onChange={(event)=>{setInputValueHandler(event)}}
                                
                                
                            />
                        </Col>
                        <Col className={styles.customControlIconCol}>
                            <span className={styles.pageTitleText2} onClick={()=>handleControlSet()}>
                            {t('Control Icon')}
                            </span>

                            {isEditEnable ?
                                <>
                                    <ImageUploadBtn
                  containerId={props.containerId} 
                                        handleImageUpload={handleIcon} 
                                        style= {{'height' : '28px', 'max-height' :' 28px', 'border-radius' : '2px'}}
                                        style2= {{'height' : '28px', 'margin-bottom' : '0px'}}
                                        iconName={ selectedControlSetIndex!==-1 ? 
                                            controlSetDetails[selectedControlSetIndex].iconName :
                                            customIconDetails.iconName
                                        }
                                    />
                                </>
                            : selectedControlSetIndex!==-1 ?
                                <>  
                                    <div className={styles.iconClass} >
                                    { selectedControlSetIndex!==-1 ? controlSetDetails[selectedControlSetIndex]?.iconName :
                                    customIconDetails?.iconName}
                                    </div>
                                </>
                            :   
                                <ImageUploadBtn
                  containerId={props.containerId} 
                                    handleImageUpload={handleIcon} 
                                    style= {{'height' : '28px', 'max-height' :' 28px', 'border-radius' : '2px'}} 
                                    style2= {{'height' : '28px', 'margin-bottom' : '0px'}}
                                    //iconName={controlSetDetails[selectedControlSetIndex] && controlSetDetails[selectedControlSetIndex].iconName}
                                    // iconName={customIconDetails.iconName}
                                    iconName={ selectedControlSetIndex!==-1 ? controlSetDetails[selectedControlSetIndex]?.iconName :
                                    customIconDetails?.iconName}
                                />
                            }


                        </Col>


                        {/* {!isEditEnable ? <Button className={styles.addButton} onClick={()=>handleControlSet('create')}> {'Add'} </Button> : 
                        <Button className={styles.addButton} onClick={()=>{
                            handleControlSet('changeLabel',inputValue) 
                            setIsEditEnable(false)}}>
                                 {'Modify'} 
                                 </Button>}  */}

                    {selectedControlSetIndex===-1 ? 
                        <Button disableFocusRipple
                        disableRipple
                        tabIndex={0} className={`${styles.addButton} formBuilder-MuiButton-outlined`}
                        onClick={()=>handleControlSet('create')}> {t('Add')} </Button> 
                    : isEditEnable  ?
                        <Button 
                        disableFocusRipple
                        disableRipple
                        tabIndex={0} className={`${styles.addButton} formBuilder-MuiButton-outlined`}
                            onClick={()=>{
                                handleControlSet('changeLabel',inputValue) 
                                setIsEditEnable(false)
                            }}
                        >
                            {t('Modify')} 
                        </Button> 
                    : 
                        <Button 
                        disableFocusRipple
                        disableRipple
                        tabIndex={0} className={`${styles.disabledModifyButton} formBuilder-MuiButton-outlined`}
                            //  onClick={()=>{handleControlSet('changeLabel',inputValue) 
                            //  setIsEditEnable(false)}}
                            disabled            
                        >
                            {t('Modify')} 
                        </Button>
                    }           
                        
                        
                    </Col>
                    
                    <Col className={styles.controlsSetDefinitionDetails}>
                    <div className={styles.header} style={translationStyles1?{textAlign:"right"}:null}>
                        {t('Properties')}
                    </div>
                    <Row className={styles.propertiesHeader}>
                        <span className={styles.propertiesTableTitle}>{controlSetDetails[selectedControlSetIndex] && controlSetDetails[selectedControlSetIndex].label}</span>
                        <span className={styles.addPropertiesText} onClick={()=> handleProperty('addpropertyRow')}>
                        <AddColumnIcon />
                        {t(' Add Property')}
                        </span>
                    </Row>
                    <TableContainer component={Paper}  className={styles.tableContainer}>
                        <Table className={[styles.tableClass].join(" ")} aria-label="simple table">
                            <TableHead>
                                <TableRow className={[ ].join(" ")}>
                                    <TableCell className={styles.col1}>
                                        {t('S. No')}
                                    </TableCell>
                                    <TableCell className={styles.col23}>
                                        {t('Property Name')}
                                    </TableCell>
                                    <TableCell className={styles.col23}>
                                        {t('Property Value')}
                                    </TableCell>
                                    <TableCell className={styles.col1}>
                                    </TableCell>
                                </TableRow >   
                            </TableHead>
                            <TableBody id={ props.currentPage } >
                            {
                            controlSetDetails && controlSetDetails[selectedControlSetIndex] && (controlSetDetails[selectedControlSetIndex]['properties']).map((propertyObj, index)=>{ 
                                return( 
                                    <TableRow className={[ ].join(" ")}>
                                    <TableCell className={[styles.cellCommon, styles.sNoCell].join(" ")}>{index + 1}</TableCell>
                                    <TableCell className={[styles.cellCommon, styles.propertyValueCell].join(" ")}>
                                        <TableTextboxForCustomControl  style={{'paddingLeft' : '16px', 'border': 'none', 'height': '100% !important'}} key={Object.keys(propertyObj)[0]} 
                                        showEditable={false  } 
                                        defaultValue={Object.keys(propertyObj)[0]} rowIndex={index}
                                        handleRowData={(value)=>handleProperty('propertyName',Object.keys(propertyObj)[0],value,index)}/>
                                    </TableCell>
                                    <TableCell className={[styles.cellCommon, styles.propertyValueCell].join(" ")}>
                                        <TableTextboxForCustomControl  style={{'paddingLeft' : '16px', 'border': 'none', 'height': '100% !important'}} key={Object.values(propertyObj)[0]} 
                                            showEditable={false }
                                            decrypted={true} 
                                            // defaultValue={Object.values(propertyObj)[0]} rowIndex={index}
                                            // defaultValue={decryptMessage(Object.values(propertyObj)[0])} 
                                            defaultValue={Object.values(propertyObj)?.[0]} 
                                            value={Object.values(propertyObj)?.[0]} 
                                            rowIndex={index}
                                            //defaultValue={decrypt(Object.values(propertyObj)[0])}
                                            //handleRowData={(value)=>handleProperty('propertyValue',Object.keys(propertyObj)[0],value,index)}/>
                                            handleRowData={async (value) => handleProperty('propertyValue', Object.keys(propertyObj)[0], await encrypt(value), index, "encrypt")}
                                        />
                                    </TableCell>
                                    <TableCell className={[styles.cellCommon, styles.sNoCell,styles.deletePropertyCell].join(" ")}>
                                        {/* <img src= {require('../../../Icons/RedCross14x14').default}  className={styles.deleteIcon}
                                        onClick={()=>handleControlSet()}/> */}
                                        <span onClick={()=>handleProperty('delete','','',index)}><RedCross /></span>
                                    </TableCell>
                                    </TableRow >  
                                    )
                                })
                            }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Col>
                </Col>
        </Row>
        <Row className={styles.backdropFooter} style={translationStyles1?{paddingLeft:"10px"}:null}>
            <Button disableFocusRipple
                        disableRipple
                        tabIndex={0} className={`${styles.cancelButton} formBuilder-MuiButton-outlined`}
                        onClick={()=>saveControlSet('Cancel')}> {t('Cancel')} </Button>
            <Button disableFocusRipple
                        disableRipple
                        tabIndex={0} className={`${styles.saveButton} formBuilder-MuiButton-outlined`}
                         disabled={disableSave} onClick={()=>saveControlSet(t('Save'))}
            style={{ opacity: disableSave ? 0.5 : 1}}
            > {t('Save')} </Button> 
        </Row>
      </div>
      {
              alertData.open === true &&
            <CustomizedAlert alertData={alertData} />
}
      </Dialog>
    </div>
  );


  function prepareControlSet(controlSetJson){ 
    
      return(
        Object.keys(controlSetJson).map((key)=>{ 
            return(
                <>
                    <Col className={[ styles.controlNameCollapsibleCol, controlSetJson[key].children ? null : styles.noChildrenControl].join(' ')}> 
                        {  controlSetJson[key].children  &&
                            <img src= {require('../../../Icons/horizontalArrow.svg').default}  className={styles.arrowIcon}
                            onClick={()=>handleControlSet()} alt='Horizontal Arrow Icon'/>
                        }
                        <input aria-label={"Delete Control Set"}  type='checkbox' key={Math.random()} index={controlSetJson.id} className={styles.controlNameCheckbox} 
                        defaultChecked={controlSetDetails[selectedControlSetIndex] && 
                        Object.keys(controlSetDetails[selectedControlSetIndex]).includes(key) === true ? true : false}
                        onClick={()=>handleControlSetDetails('addDelete',controlSetJson[key] )}/>
                        {key} 
                    </Col>
                    {  controlSetJson[key].children  &&
                        <Row className={styles.controlNameRowBody}>
                            <Col className={styles.treeLineSpan}></Col>
                            <Col className={styles.controlNameColInnerBody}>
                            {   
                                controlSetJson[key].children &&  
                                prepareControlSet(controlSetJson[key].children)
                            }
                            </Col>
                        </Row>
                    }
                </>
            )  
        }) 
      )
    }

    function readFormData(jsonData, controlSetJson,controlSetJson1){
       
        if(Array.isArray(jsonData)){
            for(let index=0; index<jsonData.length; index++){
                let item = jsonData[index];
                var component = { };
                if(item["elem_type"] && item["elem_type"]!=='row' && item["elem_type"]!=='column' ){ 
                    controlSetJson[item.id] = {'id' : item.id, 'label' : item.controlName ? item.controlName : item.id, 
                                                'elem_type' : item['elem_type'], 'checked' : 'n', 'value' : '000'} ;//console.log('object->:',i,item);
                    controlSetJson1[item.id] = false ;
                        if(item["children"]){ 
                            controlSetJson[item.id]["children"] = { } ; 
                        }                                                               
                        if(Object.keys(item).includes("children")){ 
                        readFormData(item["children"], controlSetJson[item.id]['children'] ,controlSetJson1);
                        return ;
                     }
                }
                if(Object.keys(item).includes("children")){ 
                   readFormData(item["children"], controlSetJson ,controlSetJson1);
                }
                
            }
        } else{
                if(jsonData["elem_type"] && jsonData["elem_type"]!=='row' && jsonData["elem_type"]!=='column' ){ 
                    controlSetJson[jsonData.id] = {'id' : jsonData.id, 'label' : jsonData.controlName ? jsonData.controlName : jsonData.id,
                                                    'elem_type' : jsonData['elem_type'], 'checked' : 'n', 'value' : '000'} ;
                    controlSetJson1[jsonData.id] = false ;
                    if(Object.keys(jsonData).includes("children")){ 
                        controlSetJson[jsonData.id]["children"] = { } ; 
                    }
                    if(Object.keys(jsonData).includes("children")){
                        readFormData(jsonData["children"], controlSetJson[jsonData.id]['children'], controlSetJson1);
                        return ;
                    }
                }
                if(Object.keys(jsonData).includes("children")){
                    readFormData(jsonData["children"], controlSetJson, controlSetJson1);
                }
                
        } return controlSetJson ;
    }
    
  
}